<div *ngIf="loading" class="loading-spinner">
    <div class="spinner"></div>
</div>

<div *ngIf="!loading && driver" class="text-center public-responsive">
    <h1>Enter Driver's Info</h1>
    <br />
    <div class="row">
        <div class="col-md-12 col-sm-12">
            <form [formGroup]="editDriverForm" class="form-contents" (ngSubmit)="onSubmit()">
                <div>
                    <div>
                        <label for="firstName">First Name:</label>
                        <input type="text" id="firstName" formControlName="firstName" required>
                        <div *ngIf="editDriverForm.get('firstName').errors?.required && editDriverForm.get('firstName').touched"
                            class="error-message">
                            First Name is required.
                        </div>
                        <div *ngIf="editDriverForm.get('firstName').errors?.forbiddenName && editDriverForm.get('firstName').touched"
                            class="error-message">
                            First Name cannot contain numbers or special characters.
                        </div>
                    </div>
                    <br>
                    <div>
                        <label for="lastName">Last Name:</label>
                        <input type="text" id="lastName" formControlName="lastName" required>
                        <div *ngIf="editDriverForm.get('lastName').errors?.required && editDriverForm.get('lastName').touched"
                            class="error-message">
                            Last Name is required.
                        </div>
                        <div *ngIf="editDriverForm.get('lastName').errors?.forbiddenName && editDriverForm.get('lastName').touched"
                            class="error-message">
                            Last Name cannot contain numbers or special characters.
                        </div>
                    </div>
                    <br>
                    <div>
                        <label for="phone">Phone Number:</label>
                        <input type="text" id="phone" formControlName="phone" required>
                        <div *ngIf="editDriverForm.get('phone').errors?.required && editDriverForm.get('phone').touched"
                            class="error-message">
                            Phone Number is required.
                        </div>
                        <div *ngIf="editDriverForm.get('phone').errors?.forbiddenNumber && editDriverForm.get('phone').touched"
                            class="error-message">
                            Phone Number must be 10 digits long & can only contain numerical characters.
                        </div>
                    </div>
                    <br>
                    <div>
                        <label for="carrier">Driving Company Name:</label>
                        <select id="carrier" formControlName="carrier">
                            <option *ngFor="let carrier of carriers" [value]="carrier.Id">{{ carrier.Name }}</option>
                        </select>
                    </div>
                    <br>
                    <div>
                        <label for="UsdotNumber">USDot Number:</label>
                        <input type="text" id="UsdotNumber" formControlName="UsdotNumber">
                        <div *ngIf="editDriverForm.get('UsdotNumber').errors?.forbiddenNumber && editDriverForm.get('UsdotNumber').touched"
                            class="error-message">
                            USDot Number may only contain alphanumeric characters.
                        </div>
                    </div>
                    <br>
                    <div>
                        <label for="licensePlate">License Plate:</label>
                        <input type="text" id="licensePlate" formControlName="licensePlate" required>
                        <div *ngIf="editDriverForm.get('licensePlate').invalid && editDriverForm.get('licensePlate').touched"
                            class="error-message">
                            License Plate is required.
                        </div>
                        <div *ngIf="editDriverForm.get('licensePlate').errors?.forbiddenNumber && editDriverForm.get('licensePlate').touched"
                            class="error-message">
                            License Plate may only contain alphanumeric characters.
                        </div>
                    </div>
                    <br>
                    <div class="driverNotificationOptOut-wrapper">
                        <label for="driverNotificationOptOut">Driver Notification Opt Out:</label>
                        <input type="checkbox" id="driverNotificationOptOut" formControlName="driverNotificationOptOut" class="form-check-input">
                    </div>
                    <br>
                    <div class="float-md-left">
                        <button type="submit" class="btn btn-primary" [disabled]="editDriverForm.invalid">Save</button>
                    </div>
                    <div class="float-md-right">
                        <button type="button" class="btn btn-primary" (click)="goToDriverEditTwicCardPage()">TWIC Upload</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 col-sm-12">
            <span class="new-driver-link--wrapper">
                <div class="new-driver-link">Finished Editing? Please <a (click)="goToDriverCheckInPage()">click here</a> to enter your pickup #.
                </div>
            </span>
        </div>
    </div>
    <br />
    <app-driver-check-in-support-button [driver]="driver"></app-driver-check-in-support-button>
    <br />
</div>
